var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isRN, queryParamsFromGlobal } from '@src/lib/env_detect';
import axios from 'axios';
import { SENTRY_RELEASE_LABEL, PLATFORM_VERSION } from '../monitor/sentry_config';
import via from '@bridge/byted-via-tiktok';
import { bid, domain, env, release } from './env';
import { deviceWidth, deviceHeight } from '../adjust_device';
import DataBus from '@lib/data_bus';
var toTags = function (object) {
    var returnObj = {};
    Object.keys(object).forEach(function (k) {
        if (typeof object[k] === 'object') {
            returnObj[k] = JSON.stringify(object[k]);
        }
        else {
            returnObj[k] = String(object[k]);
        }
    });
    return returnObj;
};
var isProd = true; //process.env.NODE_ENV === 'production'
var CompatibleSlardar = /** @class */ (function () {
    function CompatibleSlardar(opt) {
        this.slardar_web_id = '';
        this.slardar = null;
        this.session_id = '';
        if (!opt.domain || !opt.bid) {
            throw new Error('must provide domain and bid');
        }
        this.config = opt;
        this.axiosInstance = axios.create();
    }
    CompatibleSlardar.prototype.setWebId = function (id) {
        this.slardar_web_id = id;
    };
    CompatibleSlardar.prototype.setPid = function (pid) {
        var _a, _b;
        if (isRN) {
            this.config.pid = pid;
        }
        else {
            this.config.pid = pid;
            (_a = this.slardar) === null || _a === void 0 ? void 0 : _a.config({
                pid: pid,
            });
            (_b = this.slardar) === null || _b === void 0 ? void 0 : _b.start();
        }
    };
    Object.defineProperty(CompatibleSlardar.prototype, "reportUrl", {
        /**
         * 上报地址
         */
        get: function () {
            return "https://" + this.config.domain + "/log/sentry/v2/api/slardar/main/";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompatibleSlardar.prototype, "ravenUrl", {
        get: function () {
            return "https://key@" + this.config.domain + "/log/sentry/v2/slardar";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 初始化
     */
    CompatibleSlardar.prototype.init = function (opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var instance, user_id, slardar;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isProd) {
                            return [2 /*return*/];
                        }
                        instance = this;
                        return [4 /*yield*/, via.app.getUserInfo()];
                    case 1:
                        user_id = (_a.sent()).user_id;
                        this.setWebId(user_id);
                        // 生成一个随机字符串作为rn的session_id
                        this.session_id = Math.random().toString(36).substr(2);
                        // rn使用raven
                        if (isRN) {
                            // rn手动上报pv
                            // Raven.config(`https://key@${this.config.domain}/log/sentry/v2/slardar`, {
                            //     dataCallback: function (data) {
                            //         // 以下字段必须填充
                            //         const newData = {
                            //             bid: instance.config.bid,
                            //             pid: instance.config.pid,
                            //             ev_type: 'jserr',
                            //             sentry: data,
                            //             slardar_web_id: instance.slardar_web_id,
                            //             slardar_session_id: instance.session_id,
                            //         }
                            //         // @ts-ignore
                            //         Raven._globalEndpoint = instance.reportUrl
                            //         return newData
                            //     },
                            // }).install()
                        }
                        else {
                            slardar = opts.slardar;
                            // 非rn直接使用slardar
                            if (!slardar) {
                                throw new Error('browser must provide slardar');
                            }
                            this.slardar = slardar;
                            this.slardar.init({
                                // 不管了，写死了
                                bid: 'tiktok_promote_rn',
                                userId: user_id,
                                release: this.config.release,
                                env: this.config.env,
                            });
                            this.slardar.start();
                        }
                        this.reportPV();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CompatibleSlardar.prototype, "now", {
        get: function () {
            return Math.floor(Date.now() / 1000);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompatibleSlardar.prototype, "context", {
        get: function () {
            var _a, _b;
            return __assign({ 
                // 访问版本
                PLATFORM_VERSION: PLATFORM_VERSION,
                SENTRY_RELEASE_LABEL: SENTRY_RELEASE_LABEL, 
                /**
                 * SCM版本
                 */
                SCM_VERSION: (_a = require('./version.json')) === null || _a === void 0 ? void 0 : _a.version, 
                /**
                 * 设备宽高
                 */
                DEVICE_WIDTH: String(deviceWidth), DEVICE_HEIGHT: String(deviceHeight), 
                /**
                 * 直播参数
                 */
                LIVE: String(Number((_b = DataBus === null || DataBus === void 0 ? void 0 : DataBus.globalProps) === null || _b === void 0 ? void 0 : _b.is_from_live)) }, queryParamsFromGlobal);
        },
        enumerable: false,
        configurable: true
    });
    CompatibleSlardar.prototype.reportPV = function () {
        // 统计访问量
        this.customReport('visit');
        return this.send({
            ev_type: 'pageview',
        });
    };
    CompatibleSlardar.prototype.send = function (data) {
        if (!isProd) {
            return;
        }
        var commonData = {
            slardar_session_id: this.session_id,
            slardar_web_id: this.slardar_web_id,
            context: JSON.stringify(this.context),
            env: 'production',
            bid: this.config.bid,
            pid: this.config.pid,
        };
        console.log('send', commonData);
        return this.axiosInstance.post(this.reportUrl, __assign(__assign({}, commonData), data));
    };
    /**
     * 手动上报js错误
     */
    CompatibleSlardar.prototype.captureException = function (err) {
        var _a;
        if (!isRN) {
            (_a = this.slardar) === null || _a === void 0 ? void 0 : _a.call(this, 'captureException', err);
            return;
        }
        // Raven?.captureException(err)
    };
    CompatibleSlardar.prototype.captureMessage = function (msg, options) {
        var _a, _b;
        if (!isRN) {
            (_b = (_a = this.slardar) === null || _a === void 0 ? void 0 : _a.sendLog) === null || _b === void 0 ? void 0 : _b.call(_a, __assign({ content: msg }, options));
            return;
        }
        // Raven?.captureMessage(msg, options)
    };
    /**
     *
     * @param eventName 事件名称
     * @param tags 分组，会被处理成Record<string, string>
     * @param metrics 指标，会和{default: 1} 合并
     */
    CompatibleSlardar.prototype.customReport = function (eventName, tags, metrics) {
        var _a, _b;
        if (tags === void 0) { tags = {}; }
        if (metrics === void 0) { metrics = {}; }
        var _metrics = __assign({ default: 1 }, metrics);
        if (!isRN) {
            (_b = (_a = this.slardar) === null || _a === void 0 ? void 0 : _a.sendEvent) === null || _b === void 0 ? void 0 : _b.call(_a, { name: eventName, metrics: metrics, categories: tags });
            return;
        }
        var customCounter = {
            ev_type: 'flexible',
            flexible_data_list: [
                {
                    category: toTags(tags),
                    metrics: _metrics,
                    metrics_type: 'custom',
                    event_name: eventName,
                    timestamp: this.now,
                },
            ],
        };
        return this.send(customCounter);
    };
    return CompatibleSlardar;
}());
var compatibleSlardar = new CompatibleSlardar({
    bid: bid,
    domain: domain,
    env: env,
    release: release,
});
export default compatibleSlardar;
